export default __webpack_public_path__ + "static/media/kak.aacdfe31.webp";